module.exports = __webpack_public_path__ + "static/banner_what-we-do-ec0f2a0e00047e7b9d3ed1dfad99a0e6.png";